import { z } from 'zod';
export const Id = z.uuid();
export const Role = z.enum(['admin', 'editor', 'user']);
export const Email = z
    .email()
    .max(254)
    .transform((v) => v.trim().toLowerCase());
/** Единая политика пароля — её проверяют и формы, и API. */
export const Password = z.string().min(10, 'min_length').max(128, 'max_length');
/**
 * Момент времени. По сети — ISO-строка; coerce превращает её обратно в Date на клиенте
 * (ResponseValidationPlugin в api-client), на сервере принимает Date как есть.
 */
export const Timestamp = z.coerce.date();
export const OkResponse = z.object({ ok: z.literal(true) });
//# sourceMappingURL=common.js.map